import { render, staticRenderFns } from "./CustomerProfileInfo.vue?vue&type=template&id=14793803&"
import script from "./CustomerProfileInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerProfileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports